import React, { ReactElement } from "react";
import {HelpBox} from './HelpBox';

type NumericInputProps = {
    minValue: number;
    maxValue: number;
    title: string;
    info: string;
    default?: string;
    setValue : Function;
    editValue : string;
    setEditValue : Function;
    clearValue? : Function;
    value: string;
    validate?: Function ; // Add this for custom validation
    invalidString?: string; // If the validate function is set, use this
    completions?: Array<string>;
    showModified? : boolean;
    isModified? : Function;
    unit? : string;
    readonly? : boolean;
}

export const NumericInput = (props : NumericInputProps)  : ReactElement  => {
    const selectDefault = () : string => {
        return props.default ? props.default : "";
    }
    const initialDefaultValue = selectDefault();
    const editValue = props.editValue;
    const setEditValue = props.setEditValue;

    const [initialValue /*, setInitialValue */] = React.useState<string>(initialDefaultValue);
    const [isEditing, setIsEditing] = React.useState<boolean>(false);
    const isModified = ():boolean => {
        if (props.isModified) return props.isModified();
        return (props.showModified?true:false) && props.editValue !== initialValue;
    }
    const parseNum = (s:string) : number => {
        if (!s)
            return NaN;
        if (s.startsWith("0x") && !s.includes("."))
            return parseInt(s, 16);
        return parseFloat(s);
    }

    const validate = (v : string):boolean => {
        if (props.validate)
            return props.validate(v);
        const reDecimal = /^(-?)[0-9]+(\.([0-9]{1,2}))?$/g;
        const reHex=/^0[x]([0-9a-fA-F]){1,8}$/g;
        if (!(reDecimal.test(v) || reHex.test(v))) {
            return false;
        }

        return isFinite(parseNum(v)) && parseNum(v) >= props.minValue && parseNum(v) <= props.maxValue;
    }
    const valid:boolean = editValue === undefined || validate(editValue) || editValue==="" || props.readonly as boolean;
    const setValueLocal = (n : string) => {
        n = n.replace(",", ".");
        n = n.trim();
        setIsEditing(true);
        if (n === "" && props.clearValue)
            props.clearValue();
        else if (n === initialValue && props.clearValue)
            props.clearValue();
        else {
            if (n.startsWith("0x") && !n.includes(".")) {
                // Treat as hex input
                let n10 : string = parseInt(n.substring(2),16).toString();
                if (validate(n10))
                    props.setValue(parseInt(n10));
                else if (props.clearValue) {
                    console.log("clearing value");
                    props.clearValue(); // Remove invalid settings
                }
            }
            else {
                if (validate(n))
                    props.setValue(parseFloat(n));
                else if (props.clearValue) {
                    console.log("clearing value");
                    props.clearValue(); // Remove invalid settings
                }
            }
        }
        setEditValue(n);
    }
    const trimUnit = (s:string|undefined) : string => {return s ? s : ""}
    const displayValue:string = props.readonly ? props.value : (isEditing ? editValue : props.value);
    return <div className={isModified() ? "NumericInputBoxModified" : "NumericInputBox"}>
                <div className="Flexing2">
                <div className={isModified()?"NumericInputTitleModified":"NumericInputTitle"}>{props.title}<HelpBox name={props.title} info={props.info}/></div>
                {!props.readonly && props.value && props.editValue && (parseNum(props.value) !== parseNum(editValue)) ? <div className="NumericInputOriginal" onClick={()=>{setValueLocal(props.value); setIsEditing(false);}}>Set:{props.value}</div> : null}
                </div>
                <input className="NumericInput" type="text" readOnly={props.readonly} list={"complete+"+props.title} value={displayValue} onChange={(e)=>setValueLocal(e.target.value)}/>
                <div className="Flexing">
                    <div className="NumericUnit">{trimUnit(props.unit)}</div>
                    <div className={valid ? "NumericValidationGood" : "NumericInputValidationBad"}>{
                        valid ? (displayValue===""+props.default ? "DEFAULT" : (displayValue==="" ? "EMPTY" : "OK")) : (props.invalidString ? props.invalidString : ("Range " + props.minValue + " - " + props.maxValue))}
                </div>
                </div>
                {props.completions ? <datalist id={"complete+"+props.title}>
                {editValue.length >= 3 && props.completions ? props.completions.map((k)=><option value={k}/>) : null};
                </datalist> : null}
        </div>;
}

